import React, { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import AddonsTitle from "./AddonsTitle";
import Rotate from "components/rotate/Rotate";
import Spacer from "components/Spacer";
import Addon from "./Addon";
import Typography from "@material-ui/core/Typography";
import dlc01 from "assets/images/homePage/buyNowSection/dlc/dlc_01.png";
import dlc01Title from "assets/images/homePage/buyNowSection/dlc/title_dlc_01.png";
import dlc02 from "assets/images/homePage/buyNowSection/dlc/dlc_02.png";
import dlc02Title from "assets/images/homePage/buyNowSection/dlc/title_dlc_02.png";
import dlc03 from "assets/images/homePage/buyNowSection/dlc/dlc_03.png";
import dlc03Title from "assets/images/homePage/buyNowSection/dlc/title_dlc_03.png";
import dlc04 from "assets/images/homePage/buyNowSection/dlc/dlc_04.png";
import dlc04Title from "assets/images/homePage/buyNowSection/dlc/title_dlc_04.png";
import BuyNowButton from "../BuyNowButton";
import EditionType from "models/EditionType";
import SelectableCollection from "components/selectableCollection/SelectableCollection";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        titleContainer: { display: "flex" },
        titleContainerSpacingPlaceholder: {
            [theme.breakpoints.down("sm")]: {
                display: "none",
            },
        },
        addons: {
            display: "flex",
            justifyContent: "center",
        },
    });
});

interface IAddon {
    keyartSrc: string;
    titleImage: ReactNode;
    textContent: ReactNode;
    editionType: EditionType;
}

export default function Addons() {
    const classes = useStyles();

    const addons: IAddon[] = [
        {
            keyartSrc: dlc04,
            titleImage: <img src={dlc04Title} style={{ width: "100%", maxWidth: 400 }} />,
            textContent: (
                <>
                    <Typography gutterBottom>
                        A pair of eye-catching off-road machines, purpose-built to overcome any
                        terrain, are added to DIRT 5 in the Wild Spirits Content Pack. First up: the
                        hotly-anticipated Ford Bronco Wildtrak 2021 – the perfect addition to take
                        on our extreme events. Alongside the Bronco is the Prodrive Hunter: billed
                        as a ‘Desert Hypercar’, the Hunter has all the power you need to dominate
                        DIRT 5’s global off-road routes.
                    </Typography>
                    <Typography>
                        The Wild Spirits Content Pack also further expands our Career mode with
                        another 25 bespoke events, and two additional Career Sponsors are also
                        added: Alpinestars and VP Racing Fuels. Select either of these sponsors to
                        unlock new rewards and content, including fresh liveries and customisation
                        items.
                    </Typography>
                </>
            ),
            editionType: EditionType.WILD_SPIRITS_CONTENT_PACK,
        },
        {
            keyartSrc: dlc03,
            titleImage: <img src={dlc03Title} style={{ width: "100%", maxWidth: 400 }} />,
            textContent: (
                <>
                    <Typography gutterBottom>
                        The Super Size Content Pack certainly lives up to its name, with four huge
                        off-road machines ready to take on all terrain and all challengers – the
                        Bentley Continental GT Ice Race Car, Armada Rock Racer, Volkswagen Atlas
                        Cross Sport Baja Concept and Rezvani Tank – and another 27 bespoke events to
                        take on in a new career chapter.
                    </Typography>
                    <Typography>
                        Two more sponsors – Toblerone and Power Maxed – are available to sign for
                        and earn exclusive rewards for, including liveries, by completing their
                        objectives. More customisation items also arrive, such as stickers,
                        lanyards, and more patterns for custom liveries.
                    </Typography>
                </>
            ),
            editionType: EditionType.SUPER_SIZE_CONTENT_PACK,
        },
        {
            keyartSrc: dlc02,
            titleImage: <img src={dlc02Title} style={{ width: "100%", maxWidth: 410 }} />,
            textContent: (
                <>
                    <Typography gutterBottom>
                        Turn up the volume on your DIRT 5 experience with the Uproar Content Pack!
                        Race four legendary cars returning from ‘DiRT: Showdown’ – the Duke Coupe,
                        Jackson Adventurer, Zenden Cup and Jackson Eulogy – and take on 25 thrilling
                        new Career events set at night-time with dynamic weather scenarios.
                    </Typography>
                    <Typography>
                        Two Career sponsors – Puma and OffRoad Xtreme – are also included, with
                        connected rewards including fresh liveries. Race hard and win big to unlock
                        new Achievements/Trophies connected to Career mode!
                    </Typography>
                </>
            ),
            editionType: EditionType.UPROAR_CONTENT_PACK,
        },
        {
            keyartSrc: dlc01,
            titleImage: <img src={dlc01Title} style={{ width: "100%", maxWidth: 400 }} />,
            textContent: (
                <>
                    <Typography gutterBottom>
                        Continue your journey in the DIRT Off-Road Series with the Energy Content
                        Pack! Take control of four incredible new cars – the Porsche Taycan Turbo S,
                        Alpine A110 Sports X, GMC Sierra Pre-Runner, and Chevrolet Silverado 1500 –
                        and compete in 25 new Career events with extreme dynamic weather and
                        multi-class race options.
                    </Typography>
                    <Typography>
                        Race for two new sponsors – Xite and MadCroc – and unlock new
                        personalisation items, such as bespoke liveries, stickers, lanyards, and
                        custom livery editor options, to show off your style on the track.
                    </Typography>
                </>
            ),
            editionType: EditionType.ENERGY_CONTENT_PACK,
        },
    ];

    return (
        <div>
            <div className={classes.titleContainer}>
                <Rotate amount={-1} style={{ flex: 1 }}>
                    <AddonsTitle style={{ flex: 1 }} />
                </Rotate>
                <div className={classes.titleContainerSpacingPlaceholder} style={{ flex: 1 }}></div>
            </div>

            <Spacer size={4} />

            <div className={classes.addons}>
                <SelectableCollection
                    items={addons}
                    renderItem={(addon) => (
                        <Addon keyartSrc={addon.keyartSrc}>
                            <Rotate amount={1}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {addon.titleImage}
                                </div>

                                <Spacer />
                                {addon.textContent}
                                <Spacer size={2} />

                                <BuyNowButton edition={addon.editionType} />
                            </Rotate>
                        </Addon>
                    )}
                    transition="slide"
                />
            </div>
        </div>
    );
}
